import React, { useState, useEffect, useRef } from "react"
import { Form, Spin, Input, Row, Col, Card, Divider } from "antd"
import * as Http from "utils/http.helper"
import Breadcrumbs from "components/Common/Breadcrumb"
//Bamboo Wall Decor
import bambooWallDecor from "assets/images/transparent/PRINT/BAMBOO_WALL_DECOR/BAMBOO_WALL_DECOR.png"
//Banner Stand
import bannerStand from "assets/images/transparent/PRINT/BANNER_STAND/BANNER_STAND.png"
//Car visor
import carVisor from "assets/images/transparent/PRINT/CAR_VISOR/CAR_VISOR.png"
// golf Towel
import golfTowel from "assets/images/transparent/PRINT/GOLF_TOWEL/GOLF_TOWEL.png"
// hanging canvas
import hangingCanvas from "assets/images/transparent/PRINT/HANGING_CANVAS/HANGING_CANVAS.png"

// Banner
import banner from "assets/images/transparent/PRINT/BANNER/BANNER.png"
// cake
import cakeTopper from "assets/images/transparent/PRINT/CAKE_TOPPER/CAKE_TOPPER.png"
//canvas
import canvas from "assets/images/transparent/PRINT/CANVAS/CANVAS.png"
//doormat
import doormat from "assets/images/transparent/PRINT/DOORMAT/DOORMAT.png"
//label
import labelImage from "assets/images/transparent/PRINT/LABEL/LABEL.png"
//mug
import mugBack from "assets/images/transparent/PRINT/MUG/MUG_BACK.png"
import mugFront from "assets/images/transparent/PRINT/MUG/MUG_FRONT.png"
//name flag
import nameFlag from "assets/images/transparent/PRINT/NAME_FLAG/NAME_FLAG.png"
//table runner
import tableRunner from "assets/images/transparent/PRINT/TABLE_RUNNER/TABLE_RUNNER.png"
//photo frame
import photoFrameWhite from "assets/images/transparent/PRINT/PHOTO_FRAME/PHOTO_FRAME_WHITE.png"
//wall hangings
import wallHangings from "assets/images/transparent/PRINT/WALL_HANGINGS/WALL_HANGINGS.png"

//ornament
import ornamentHeart from "assets/images/transparent/PRINT/ORNAMENT/ORNAMENT_HEART.png"
import ornamentRound from "assets/images/transparent/PRINT/ORNAMENT/ORNAMENT_ROUND.png"

//puzzle
import puzzleHeart from "assets/images/transparent/PRINT/PUZZLE/PUZZLE_HEART.png"
import puzzleRectangle from "assets/images/transparent/PRINT/PUZZLE/PUZZLE_RECTANGLE.png"
//sticker
import ketchupSticker from "assets/images/transparent/PRINT/KETCHUP_STICKER/KETCHUP_STICKER.png"
import nutellaSticker from "assets/images/transparent/PRINT/NUTELLA_STICKER/NUTELLA_STICKER.png"
//trinket
import trinketHeart from "assets/images/transparent/PRINT/TRINKET/TRINKET_HEART.png"
import trinketRound from "assets/images/transparent/PRINT/TRINKET/TRINKET_ROUND.png"
import trinketSquare from "assets/images/transparent/PRINT/TRINKET/TRINKET_SQUARE.png"

//yard sign
import yardSignVertical from "assets/images/transparent/PRINT/YARD_SIGN/YARD_SIGN_VERTICAL.png"
import yardSignHorizontal from "assets/images/transparent/PRINT/YARD_SIGN/YARD_SIGN_HORIZONTAL.png"

import ImageComponent from "components/image"
import config from "config"

import error from "assets/images/error-img.png"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
import "./style.scss"
import { getEncodedS3Url } from "utils/encodedS3url"

const optionGroup = [
  {
    value: "front",
    label: "Front View",
  },
  {
    value: "back",
    label: "Back View",
  },
  {
    value: "vertical",
    label: "Vertical View",
  },
  {
    value: "heart",
    label: "Heart View",
  },
  {
    value: "round",
    label: "Round View",
  },
  {
    value: "square",
    label: "Square View",
  },
  {
    value: "horizontal",
    label: "Horizontal View",
  },
  {
    value: "ketchup",
    label: "Ketchup View",
  },
  {
    value: "nutella",
    label: "Nutella View",
  },
  {
    value: "rectangle",
    label: "Rectangle View",
  },
]

const PrintUvPrintPrinter = () => {
  //meta title
  document.title = "Print Printer Page | EASY JET CONNECT"
  const [form] = Form.useForm()
  const inputRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [info, setInfo] = useState([])
  const [userInfo, setUserInfo] = useState(null)
  const [orderId, setOrderId] = useState(null)
  const [boxLoading, setBoxLoading] = useState(false)

  useEffect(() => {
    const info = JSON.parse(localStorage.getItem("authUserV0"))
    setUserInfo(info)
    inputRef.current && inputRef.current.focus()
  }, [])

  const handleInputChange = e => {
    if (e.key === "Enter" && e.target.value.length > 0) {
      console.log(e.target.value, "e.target.value")
      getOrder(e.target.value)
      setOrderId(e.target.value)
      setTimeout(() => {
        inputRef?.current?.focus()
      }, 500)
    }
  }

  const handleInputBlur = e => {
    if (e.target.value.length > 0) {
      getOrder(e.target.value)
      setOrderId(e.target.value)
    }
    setTimeout(() => {
      inputRef.current && inputRef.current.focus()
    }, 750)
  }

  const getOrder = value => {
    const orderStatus =
      JSON.parse(localStorage.getItem("authUserV0"))?.actions?.length > 0
        ? JSON.parse(localStorage.getItem("authUserV0"))?.actions?.length > 0 &&
          JSON.parse(localStorage.getItem("authUserV0"))?.actions[0] ===
            "Completed"
          ? 50
          : 60
        : 0
    form.setFieldsValue({
      barcode: "",
    })
    setLoading(true)
    Http.get(
      `api/orders/GetPrintOrderImagesByOrderId?orderId=${value}&status=${orderStatus}&categoryId=7&subCategoryId=5`
    )
      .then(res => {
        if (res?.success && res?.data?.length > 0) {
          setInfo(res.data)
          JSON.parse(localStorage.getItem("authUserV0"))?.actions?.length > 0 &&
            JSON.parse(localStorage.getItem("authUserV0"))?.actions[0] ===
              "Completed" &&
            getDesignById(value)
        } else {
          toastr.error(
            `${value} numaralı order henüz print etmek için hazır olmayabilir (Has Image=false) ve ya order numaranız hatalı olabilir. Kontrol ediniz!`
          )
          setInfo([])
        }
        setLoading(false)
      })
      .catch(function (error) {
        setInfo([])
        toastr.error(error?.response?.data?.Message)
        setLoading(false)
      })
  }
  const getDesignById = value => {
    setLoading(true)
    try {
      fetch(`${config.apiUrl}/api/orders/DownloadPrintFiles`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json; charset=utf-8",
        },
        body: JSON.stringify({
          orderId: value,
          subCategoryId: 5,
        }),
      })
        .then(response => {
          if (!response.ok) {
            throw new Error("Network response was not ok")
          }
          return response.blob()
        })
        .then(blob => {
          const downloadUrl = window.URL.createObjectURL(blob)
          const link = document.createElement("a")
          link.href = downloadUrl
          link.download = `${value}`
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          setLoading(false)
        })
        .catch(error => {
          setLoading(false)
        })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content mb-3">
        <Spin spinning={loading}>
          <Breadcrumbs title="Print Uv Print Complete" />
          <Card className="mt-3">
            <Row className="align-items-center" gutter={[16, 16]}>
              <Col lg={8}>
                <Form form={form} layout="vertical">
                  <Row gutter={[16, 16]}>
                    <Col lg={24}>
                      <Form.Item label="Order Number" name="barcode">
                        <Input
                          ref={inputRef}
                          onPressEnter={e => handleInputChange(e)}
                          onBlur={e => handleInputBlur(e)}
                          onKeyUp={e => handleInputChange(e)}
                          onChange={e => handleInputChange(e)}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>

            {info?.length > 0 && (
              <Row gutter={[16, 16]}>
                <Col
                  lg={24}
                  style={{
                    display: "flex",
                    paddingBottom: 10,
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: 18,
                    fontWeight: "bold",
                  }}
                >
                  Order Number: {orderId}
                </Col>
                <Col
                  lg={24}
                  style={{
                    display: "flex",
                    paddingBottom: 10,
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: 17,
                  }}
                >
                  Notes: {info?.note}
                </Col>
                {info.map((item, index) => {
                  let labelName = optionGroup.find(
                    x => x.value === item?.positionCode
                  )

                  let imageUrl = null
                  const label = item?.styleName

                  switch (item?.positionCode) {
                    case "front":
                      imageUrl =
                        label === "Banner"
                          ? banner
                          : label === "Tent Banner"
                          ? banner
                          : label === "Cake Topper"
                          ? cakeTopper
                          : label === "Canvas"
                          ? canvas
                          : label === "Doormat"
                          ? doormat
                          : label === "Label"
                          ? labelImage
                          : label === "Frame"
                          ? photoFrameWhite
                          : label === "Wall Hangings"
                          ? wallHangings
                          : label === "Car Visor"
                          ? carVisor
                          : label === "Bamboo Wall Decor"
                          ? bambooWallDecor
                          : label === "Table Runner"
                          ? tableRunner
                          : label === "Ketchup Sticker"
                          ? ketchupSticker
                          : label === "Nutella Sticker"
                          ? nutellaSticker
                          : label === "Hanging Canvas"
                          ? hangingCanvas
                          : label === "Banner Stand"
                          ? bannerStand
                          : label === "Golf Towel"
                          ? golfTowel
                          : label === "Name Flag"
                          ? nameFlag
                          : label === "Mug"
                          ? mugFront
                          : doormat // Default image
                      break
                    case "heart":
                      imageUrl =
                        label === "Ornament"
                          ? ornamentHeart
                          : label === "Puzzle"
                          ? puzzleHeart
                          : label === "Trinket Dish"
                          ? trinketHeart
                          : doormat // Default image
                      break
                    case "back":
                      imageUrl = label === "Mug" ? mugBack : doormat // Default image
                      break
                    case "round":
                      imageUrl =
                        label === "Ornament"
                          ? ornamentRound
                          : label === "Trinket Dish"
                          ? trinketRound
                          : doormat // Default image
                      break
                    case "rectangle":
                      imageUrl = label === "Puzzle" ? puzzleRectangle : doormat // Default image
                      break
                    case "square":
                      imageUrl =
                        label === "Trinket Dish" ? trinketSquare : doormat // Default image
                      break
                    case "vertical":
                      imageUrl =
                        label === "Yard Sign" ? yardSignVertical : doormat // Default image
                      break
                    case "horizontal":
                      imageUrl =
                        label === "Yard Sign" ? yardSignHorizontal : doormat // Default image
                      break
                    default:
                      imageUrl = doormat // Default image
                  }
                  const css = `
                  .img_${item?.positionCode}{
                  position:absolute;
                  top:29%;
                  left:29%;
                  z-index:1;
                  width:150px;
                  height:150px;
                    ${
                      item?.colorHexCode === "#fff" ||
                      item?.colorHexCode === "#ffffff" ||
                      item?.colorHexCode === "#000" ||
                      item?.colorHexCode === "#000000"
                        ? "background-color:#e8e8e8ad"
                        : ""
                    }
                  }
                  `
                  return (
                    <Col xs={6} key={index + "-col"}>
                      <style>{css}</style>
                      <Card
                        title={labelName?.label}
                        hoverable
                        id={item.positionCode}
                        key={index + "-file"}
                        style={{
                          padding: "10px",
                          border: "1px solid #c5c5c58f",
                        }}
                      >
                        <Spin spinning={boxLoading}>
                          <div style={{ background: item?.colorHexCode }}>
                            <ImageComponent
                              key={`tshirt_${index}]`}
                              imageUrl={imageUrl}
                              width="100%"
                              height="100%"
                              preview={false}
                            />
                          </div>
                          <div
                            className={
                              item?.positionCode +
                              " " +
                              item?.styleName?.toLowerCase() +
                              " printer " +
                              `img_${item?.positionCode}`
                            }
                            key={`div_${index}]`}
                            style={{
                              backgroundImage: `url(${getEncodedS3Url(
                                item?.imageUrl
                              )})`,
                              border: "red 1px dashed",
                              backgroundSize: "contain",
                              backgroundRepeat: "no-repeat",
                              backgroundPosition: "bottom",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          />

                          <Divider />
                          <Row gutter={[16, 16]}>
                            <Col lg={10}>
                              Style:{" "}
                              <span className="text-primary">
                                {item?.styleName}
                              </span>
                            </Col>
                            <Col lg={14}>
                              Sku:{" "}
                              <span className="text-primary">{item?.sku}</span>
                            </Col>

                            <Col lg={10}>
                              Color:{" "}
                              <span className="text-primary">
                                {item?.colorName}
                              </span>
                            </Col>
                            <Col lg={7}>
                              Size:{" "}
                              <span className="text-primary">
                                {item?.sizeName}
                              </span>
                            </Col>

                            <Col lg={7}>
                              {" "}
                              Price:{" "}
                              <span
                                className="text-primary"
                                style={{ marginRight: 15 }}
                              >
                                ${item?.totalPrice}
                              </span>
                            </Col>
                          </Row>
                        </Spin>
                      </Card>
                    </Col>
                  )
                })}
              </Row>
            )}
            {info?.length === 0 && (
              <>
                <Row gutter={[16, 16]}>
                  {" "}
                  <Col lg={8}>
                    <div className="text-center mb-5">
                      <h4 className="text-uppercase">
                        Lütfen Order Numarası İle arama yapınız!
                      </h4>
                    </div>
                  </Col>
                </Row>
                <Row gutter={[16, 16]} className="justify-content-center">
                  <Col lg={24}>
                    <div>
                      <img src={error} alt="" className="img-fluid" />
                    </div>
                  </Col>
                </Row>
              </>
            )}
          </Card>
        </Spin>
      </div>
    </React.Fragment>
  )
}

export default PrintUvPrintPrinter
